import React, { Component } from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line @typescript-eslint/ban-types
export default class DefaultErrorComponent extends Component {
    render() {
        return (React.createElement("div", { className: 'error' },
            React.createElement("div", null, "An Error Occurred"),
            React.createElement("div", null, JSON.stringify(this.props.error, null, 2)),
            React.createElement("div", null, this.props.info ? JSON.stringify(this.props.info, null, 2) : '')));
    }
}
DefaultErrorComponent.propTypes = {
    error: PropTypes.object,
    info: PropTypes.object
};
//# sourceMappingURL=DefaultErrorComponent.js.map